// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2yZ7x","footer":"ModalCreateQualiphyProcedure_footer__1gJOT","additionData":"ModalCreateQualiphyProcedure_additionData__1VCHK"};